import { Component, OnInit,ViewChild } from '@angular/core';
import { WebService } from '../shared/services/web.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import cloneDeep from 'lodash/cloneDeep';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { HttpHeaders } from '@angular/common/http';
import * as moment from 'moment';
import * as momentz from 'moment-timezone';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';


interface DataItem {
  event_name: string;
  start_date: string;
  end_date: string;
  lead_form_name: string;
  emailNames: any;
  access_group_name: string;
  checked: boolean;
}

interface ColumnItem {
  name: string;
  sortOrder: NzTableSortOrder | null;
  sortFn: NzTableSortFn<DataItem> | null;
  sortDirections: NzTableSortOrder[];
}
import { NzTableSortFn, NzTableSortOrder } from 'ng-zorro-antd/table';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { isTooltipEmpty } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.css'],
})
export class EventComponent implements OnInit {
  eventForm: FormGroup;
  metadata: any;
  eventData: any[];
  eventDataRaw: any[];
  loadingFlag: boolean;
  sortName: string;
  sortValue: string;
  categoryList: any[];
  categoryFilterList: any[];
  selectedCategories: any[];
  loadComplete: boolean = false;
  updateMode: boolean;
  rawUpdateData: any;
  checkedData: any[];
  isIndeterminate: boolean;
  allChecked: boolean;
  anyChecked: boolean;
  valueInput: any;
  valueSubs: any;
  visible: boolean;
  eventFormVisible: boolean;
  groupList: any[];
  groupFilterList: any[];
  leadList: any[];
  attractLoopList: any[];
  eventLeadList: any;
  eventLeadFilterList: any[];
  selectedEventLeads: any;
  spinner: any;
  updateEventId: any;
  isLoading: boolean = false;
  archived: boolean = false;
  active: boolean = false;
  isUsedInLast30Days: boolean = false;
  last30days: any;
  filterVisible: boolean;
  searchTerm:string;

  listOfColumns: ColumnItem[] = [
    {
      name: 'Name',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.event_name.localeCompare(b.event_name),
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Start Date',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.start_date.localeCompare(b.start_date),
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'End Date',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.end_date.localeCompare(b.end_date),
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Lead Form',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.lead_form_name.localeCompare(b.lead_form_name),
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Send Leads to',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
      a.emailNames.localeCompare(b.emailNames),
      // sortFn: (a: DataItem, b: DataItem) => {
      //   const leadA = a.leads.map((leadObj) => leadObj.email).join(', ');
      //   const leadB = b.leads.map((leadObj) => leadObj.email).join(', ');
      //   return leadA.localeCompare(leadB);
      // },
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Group',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.access_group_name.localeCompare(b.access_group_name),
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Active',
      sortOrder: null,
      sortFn: null,
      sortDirections: [],
    },
    {
      name: 'Actions',
      sortOrder: null,
      sortFn: null,
      sortDirections: [],
    },
  ];
  filteredEvents: any[];
  eventDataResponse: any;
  eventClone: any[];
  filteredData: any;
  loadingSwitch: any;
  filteredDataItems: any[];
  submitFlag: boolean;
  showLoad: boolean;
  appliedFilters: any[];

  constructor(
    private webapi: WebService,
    private fb: FormBuilder,
    private notification: NzNotificationService,
    private modal: NzModalService
  ) {
    this.eventForm = this.fb.group({
      event_name: [null, [Validators.required]],
      start_date: [null, [Validators.required]],
      end_date: [null, [Validators.required]],
      lead_form_id: [null, [Validators.required]],
      attract_loop_id: [null, [Validators.required]],
      access_group_id: [null],
      is_active: [true],
    });
    this.eventData = [];
    // this.getEventData();
    this.getEventList({ filters: [] });
    this.getMetadata();
    this.categoryFilterList = [];
  }

  confirmModal?: NzModalRef;
  showConfirm(): void {
    this.confirmModal = this.modal.confirm({
      nzTitle:
        'All unsaved changes will be lost. Do you wish to proceed with closing the form?',
      nzContent: '',
      nzCentered: true,
      nzOnOk: () => {
        this.eventFormVisible = false;
      },
    });
  }

  originalFormValue: any;
  checkFormState() {
    if (this.isFormNotEmpty()) {
      this.showConfirm();
      return;
    }
    this.eventFormVisible = false;
  }
  setOriginalFormValue(): void {
    this.originalFormValue = { ...this.eventForm.value };
  }

  

  hasFormChanged(): boolean {
    if (!this.originalFormValue) {
      return false;
    }

    const formControls = this.eventForm.controls;
    for (const controlName in formControls) {
      if (formControls.hasOwnProperty(controlName)) {
        const originalValue = this.originalFormValue[controlName];
        const currentValue = formControls[controlName].value;
        if (originalValue != currentValue) {
          return true;
        }
        // console.log('SELECTED EVENT LEADS', this.selectedEventLeads)
        // if (this.selectedEventLeads.length !== 0) {
        //   return true;
        // }
      }
    }
    if(this.currentEventLeadsholder.length > 0 || this.selectedEventLeads.length > 0) {
      if (this.currentEventLeadsholder !== this.selectedEventLeads) {
        return true;
      }
    }
    

    return false;
  }

  isFormNotEmpty(): boolean {
    if (this.eventForm.controls) {
      if (this.hasFormChanged()) return true;
      else return false;
    } else {
      // if (this.selectedEventLeads !== null && this.selectedEventLeads !== '') {
      //   return true;
      // }
      for (const controlName in this.eventForm.controls) {
        if (this.eventForm.controls.hasOwnProperty(controlName)) {
          const control = this.eventForm.get(controlName);
          if (control && control.value !== null && control.value !== '') {
            return true;
          }
        }
      }

      return false;
    }
  }

  ngOnInit() {}

  // async getEventData() {
  //   try {
  //     let httpOptions = {
  //       headers: new HttpHeaders({
  //         'Content-Type': 'text/plain',
  //         'Access-Control-Allow-Origin': '*',
  //       }),
  //       observe: 'response' as 'body',
  //       responseType: 'text' as 'json',
  //     };
  //     const response = await this.webapi
  //       .requestJson('getEvent', httpOptions)
  //       .toPromise();
  //     const responseData = JSON.parse(response.body);
  //     this.eventDataRaw = [...responseData.data];
  //     this.eventDataRaw.forEach((event) => {
  //       event.checked = false;
  //       event.emailNames = '';
  //       event.start_date_show = momentz.tz(event.start_date, 'America/Chicago').format('MMM DD YYYY, HH:mm z');
  //       event.end_date_show = momentz.tz(event.end_date, 'America/Chicago').format('MMM DD YYYY, HH:mm z');

  //       event.leads.forEach((addEvent, index) => {
  //         if (index === event.leads.length - 1) {
  //           event.emailNames += addEvent.email;
  //         } else {
  //           event.emailNames += addEvent.email + ', ';
  //         }
  //       });
  //     });

  //     this.eventData = this.eventDataRaw.filter(
  //       (event) => event.is_deleted === 0
  //     );
  //     if (this.isLoading) {
  //       this.isLoading = false;
  //     }
  //     return true;
  //   } catch (error) {
  //     throw error;
  //   }
  // }

  getEventList({ filters }): void {
    this.showLoad = true;
    this.webapi
      .requestJson('getEvent', {
        Filters: filters.map((file) => {
          return {
            Key: file.key,
            Values: file.values,
          };
        }),
      })
      .subscribe(
        (data) => {
          let response = JSON.parse(data.body);
          this.eventData = [...response.data];
          this.eventData.forEach((event) => {
            event.checked = false;
            event.emailNames = '';

            event.leads.forEach((addEvent, index) => {
              if (index === event.leads.length - 1) {
                event.emailNames += addEvent.email;
              } else {
                event.emailNames += addEvent.email + ', ';
              }
            });
          });
          this.showLoad = false;

          this.eventDataRaw = cloneDeep(this.eventData)
        },
        (error) => {
          console.log('ERROR', error);
          this.showLoad = false;
          this.createNotification('error', '', 'An error occurred. Please try again later.');
        }
      );
  }

  async onApplyButtonClick() {
    try {
      await this.filterEventData();
    } catch (error) {
      // Handle error
      console.error('Error applying filters:', error);
    }
  }

  // filterEventData() {
  //   this.isLoading = true;
  //   if (this.active && this.archived) {
  //     this.eventData = this.eventDataRaw.filter((event) => {
  //       this.isLoading = false;
  //       this.filterVisible = false;
  //       return event.is_active || event.is_deleted;
  //     });
  //   } else {
  //     this.eventData = this.eventDataRaw.filter((event) => {
  //       this.isLoading = false;
  //       this.filterVisible = false;
  //       return (
  //         (!this.active || event.is_active) &&
  //         (!this.archived || event.is_deleted) &&
  //         (!this.usedInLast30Days || this.isEventInLast30Days(event))
  //       );
  //     });
  //   }
  //   if (!this.active && !this.archived && !this.usedInLast30Days) {
  //     this.isLoading = false;
  //     this.filterVisible = false;
  //     this.eventData = this.eventDataRaw.filter(
  //       (event) => event.is_deleted === 0
  //     );
  //     // [...this.eventData];
  //   }
  // }

  filterEventData() {
    this.appliedFilters = [];

    // if (this.isUsedInLast30Days) {
    //   this.appliedFilters.push({ key: 'status', values: ['0'] });
    //   this.filterVisible = false;
    // }

    if (this.active) {
      this.appliedFilters.push({ key: 'status', values: ['1'] });
      this.filterVisible = false;
    }

    if (this.archived) {
      this.appliedFilters.push({ key: 'status', values: ['2'] });
      this.filterVisible = false;
    }

    this.getEventList({ filters: this.appliedFilters });
    this.filterVisible = false;
  }

  isEventInLast30Days(event: any): boolean {
    const eventDate = new Date(event.timestamp);
    const currentDate = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(currentDate.getDate() - 30);
    return eventDate >= thirtyDaysAgo && eventDate <= currentDate;
  }

  isEventWithinLast30Days(timestamp: string): boolean {
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

    const eventDate = new Date(timestamp);
    return eventDate >= thirtyDaysAgo;
  }

  getMetadata(): void {
    // 'event'
    this.webapi
      .requestJson('getMetaData', {
        metadata: ['group', 'lead_form', 'attract_loop', 'event_lead'],
      })
      .subscribe(
        (data) => {
          let response = JSON.parse(data.body);
          this.metadata = cloneDeep(response.data);
          // this.eventClone = [...this.metadata['eventData']];
          // this.eventData = [
          //   ...this.metadata['eventData'].filter(
          //     (event) => event.is_deleted === 0
          //   ),
          // ];

          this.groupList = [...this.metadata['group']];
          this.leadList = [...this.metadata['leadFormData']];
          this.attractLoopList = [...this.metadata['attractLoopData']];
          this.eventLeadList = [...this.metadata['eventLeadData']];
          this.groupFilterList = [];
          this.groupList.forEach((element) => {
            this.groupFilterList.push({
              text: element.name,
              value: element.access_group_id,
              byDefault: false,
            });
          });

          this.eventLeadFilterList = [];
          this.eventLeadList.forEach((element) => {
            this.eventLeadFilterList.push({
              text: element.email,
              value: element.event_lead_id,
              byDefault: false,
            });
          });

          // this.eventData.forEach((event) => {
          //   event.checked = false;
          //   event.emailNames = '';
          //   event.start_date_show = momentz.tz(event.start_date, 'America/Chicago').format('MMM DD YYYY, HH:mm z');
          //   event.end_date_show = momentz.tz(event.end_date, 'America/Chicago').format('MMM DD YYYY, HH:mm z');

          //   event.leads.forEach((addEvent, index) => {
          //     if (index === event.leads.length - 1) {
          //       event.emailNames += addEvent.email;
          //     } else {
          //       event.emailNames += addEvent.email + ', ';
          //     }
          //   });
          // });

          // this.eventDataRaw = cloneDeep(this.eventData);
        },
        (error) => {
          // this.showLoad = false;
          this.createNotification('error', '', 'An error occurred. Please try again later.');
        }
      );
  }

  clickFilter() {
    // this.getResourceList({ filters: [] });
    this.filterVisible = false;
    if (this.appliedFilters && this.appliedFilters.length > 0) {
        // this.isUsedInLast30Days = this.appliedFilters.some(filter => filter.values.includes('0'));
        this.active = this.appliedFilters.some(filter => filter.values.includes('1'));
        this.archived = this.appliedFilters.some(filter => filter.values.includes('2'));
    } else {
        // this.isUsedInLast30Days = false;
        this.active = false;
        this.archived = false;
    }
}

  // clickFilter() {
  //   this.archived = false;
  //   this.eventData = this.eventDataRaw;
  //   this.filterVisible = false;
  // }

  onPopoverVisibleChange(visible: boolean) {
    if (!visible) {
      this.clickFilter()
    } else {
      console.log('Popover is now visible');
    }
  }
  

  openEventForm(): void {
    this.resetEventForm();
    this.eventFormVisible = true;
  }

  closeEventForm(): void {
    this.resetEventForm();
    this.eventData = cloneDeep(this.eventDataRaw);
    this.eventFormVisible = false;
  }

  resetEventForm(): void {
    this.eventForm.reset();
    this.startValue = null;
    this.endValue = null;
    this.currentEventLeadsholder = [];
    this.selectedEventLeads = [];
    this.updateMode = false;
    this.updateEventId = undefined;

    this.rawUpdateData = {};
    this.originalFormValue = this.eventForm.value;
  }

  resetUpdateForm(): void {
    this.eventForm.patchValue(this.rawUpdateData);
    this.selectedEventLeads = [];
    this.rawUpdateData.leads.forEach((element) => {
      this.selectedEventLeads.push(element.event_lead_id);
    });
  }

  submitEvent(): void {
    this.isLoading = true;
    let eventFormValue = this.eventForm.value;
    let obj = {
      event_name: eventFormValue.event_name,
      start_date: eventFormValue.start_date,
      end_date: eventFormValue.end_date,
      lead_form_id: eventFormValue.lead_form_id,
      attract_loop_id: eventFormValue.attract_loop_id,
      access_group_id: eventFormValue.access_group_id,
      EventLeads: [...this.selectedEventLeads],
    };

    // let utcStart = moment(obj.start_date).format('MM-DD-YYYY');
    // utcStart = utcStart + '-06:00';
    // obj.start_date = moment(utcStart).utc().format();

    // // Convert EndDate to Chicago time
    // let utcEnd = moment(obj.end_date).format('MM-DD-YYYY');
    // utcEnd = utcEnd + '-06:00';
    // obj.end_date = moment(utcEnd).utc().format();

    this.webapi.requestJson('addEvent', obj).subscribe(
      (data) => {
        var response = JSON.parse(data.body);
        this.isLoading = false;
        this.getEventList({ filters: [] });
        this.createNotification('success', '', response['message']);
        this.closeEventForm();
        // this.eventData = [...response.data];
        // this.eventData.forEach((event) => {
        //   event.checked = false;
        //   event.emailNames = '';
        //   event.emailNames = event.leads.map((lead) => lead.email).join(', ');
        // });

        // this.eventDataRaw = cloneDeep(this.eventData);
      },
      (error) => {
        this.isLoading = false;
        this.createNotification('error', '', 'An error occurred. Please try again later.');
      }
    );
  }
  currentEventLeadsholder;
  fillEventForm(data: any): void {
    
    this.openEventForm();
    this.eventForm.patchValue(data);
    this.selectedEventLeads = [];
    this.currentEventLeadsholder = [];
    data.leads.forEach((element) => {
      this.selectedEventLeads.push(element.event_lead_id);
    });
    this.currentEventLeadsholder=this.selectedEventLeads;
    this.updateMode = true;
    this.updateEventId = data.id;
    this.rawUpdateData = { ...data };
    this.originalFormValue = this.eventForm.value;
    this.startValue=data.start_date;
    this.endValue=data.end_date;
    // console.log(this.originalFormValue)
  }

  updateEvent(): void {
    this.isLoading = true;
    let updateObj = {
      event_id: this.updateEventId,
      ...this.eventForm.value,
      leads: this.selectedEventLeads,
    };

    this.webapi.requestJson('updateEvent', updateObj).subscribe(
      (data) => {
        var response = JSON.parse(data.body);
        this.isLoading = false;
        this.getEventList({ filters: [] });
        this.createNotification('success', '', response['message']);
        this.closeEventForm();
        // this.eventData = [...response.data];
        // this.eventData.forEach((event) => {
        //   event.checked = false;
        //   event.emailNames = '';
        //   event.emailNames = event.leads.map((lead) => lead.email).join(', ');
        // });
        // this.eventDataRaw = cloneDeep(this.eventData);
      },
      (error) => {
        this.isLoading = false;
        this.createNotification('error', '', 'An error occurred. Please try again later.');
      }
    );
  }

  checkAll(value: boolean): void {
    this.eventData.forEach((data) => {
      data.checked = value;
    });
    this.refreshStatus();
  }

  refreshStatus(): void {
    this.checkedData = [];
    this.eventData.forEach((element) => {
      if (element.checked) {
        this.checkedData.push(element.access_group_id);
      }
    });
    this.anyChecked = this.eventData.some((e) => e.checked);
    this.allChecked = this.eventData.every((e) => e.checked);
  }

  deleteEvent(eventId: number = null, multi = false): void {
    this.showLoad = true;
    let obj = {
      event_id: [eventId],
    };
    if (multi) {
      obj.event_id = [];
      obj.event_id = this.checkedData;
    }
    this.loadingFlag = true;
    this.webapi.requestJson('deleteEvent', obj).subscribe(
      (data) => {
        var response = JSON.parse(data.body);
        this.isLoading = false;
        this.createNotification('success', '', 'Deletion successful.');
        this.getEventList({ filters: [] });

        this.anyChecked = false;
        // this.eventData = response.data.filter(
        //   (event) => event.is_deleted === 0
        // );
      },
      (error) => {
        this.isLoading= false;
        this.createNotification('error', '', 'An error occurred. Please try again later.');
        this.getEventList({ filters: [] });
        this.anyChecked = false;
      }
    );
  }

  onKeyUp(query: string): void {
    console.log("this is query",query);
    if (query) {
      let q: string;
      q = query.toLowerCase();
      const searchData = this.eventDataRaw.filter((d) => {
        var found = false;

        if (
          (d.event_name && d.event_name.toLowerCase().includes(q)) ||
          (d.start_date && d.start_date.toLowerCase().includes(q)) ||
          (d.end_date && d.end_date.toLowerCase().includes(q)) ||
          (d.lead_form_name && d.lead_form_name.toLowerCase().includes(q)) ||
          (d.access_group_name &&
            d.access_group_name.toLowerCase().includes(q)) ||
          (d.emailNames && d.emailNames.toLowerCase().includes(q)) ||
          found
        ) {
          return d;
        }
      });
    console.log("this is searchData",searchData);

      this.eventData = searchData;
      this.eventData = [...this.eventData];
    } else {

      this.eventData = [...this.eventDataRaw];
    }
  }
  resetSearch(){
    if(this.searchTerm){
      this.searchTerm = '';
      this.eventData = [...this.eventDataRaw];

  


    }
  }

  createNotification(type, title, msg): void {
    this.notification.create(type, title, msg);
  }

  applyEventFilter() {
    if (this.archived) {
      this.eventData = this.eventDataRaw.filter(
        (event) => event.is_deleted === 1
      );
      this.filterVisible = false;
    } else if (this.archived && this.active) {
      this.eventDataRaw.filter(
        (event) => event.is_active === 1 && event.is_deleted === 0
      );
      this.filterVisible = false;
    } else {
      // this.getMetadata();
      // this.getEventData();
      this.filterVisible = false;
    }
  }

  switchValue = false;
  loading = false;

  // clickSwitch(item): void {
  //   if (!this.loadingSwitch) {
  //     const modal = this.modal.confirm({
  //       nzTitle: 'Are you sure to make this resource as in-active ?',
  //       nzContent: '',
  //       nzOkText: 'OK',
  //       nzCancelText: 'Cancel',
  //       nzOnOk: () => {
  //         this.updateToggleState(item);
  //       },
  //     });

  //     modal.afterClose.subscribe((result) => {
  //       if (!result) {
  //         console.log('Update status canceled');
  //       }
  //     });
  //   }
  // }

  clickSwitch(item): void {
    if (!this.loadingSwitch) {
      let nzTitle: string;
      if (item.is_active) {
        nzTitle = 'Are you sure to make this event as in-active?';
      } else {
        nzTitle = 'Are you sure to make this event as active?';
      }
  
      const modal = this.modal.confirm({
        nzTitle: nzTitle,
        nzContent: '',
        nzOkText: 'OK',
        nzCancelText: 'Cancel',
        nzOnOk: () => {
          this.loadingSwitch = true;
          return new Promise<void>((resolve, reject) => {
            this.updateToggleState(item, resolve, reject);
          });
        },
      });
  
      modal.afterClose.subscribe((result) => {
        if (!result) {
          console.log('Update status canceled');
        }
      });
    }
  }
  

  updateToggleState(item , resolve, reject): void {
    let obj;
    obj = {
      event_id: item.id,
      is_active: !item.is_active,
    };
    this.webapi.requestJson('updateStatus', obj).subscribe(
      (data) => {
        const response = JSON.parse(data.body);
        this.getEventList({ filters: [] });
        this.loadingSwitch = false;
        resolve();

        // this.getMetadata()
        // this.getEventData();
      },
      (error) => {
        console.error('Error updating status', error);
        this.loadingSwitch = false;
        // this.showLoad = false;
        this.createNotification('error', '', 'An error occurred. Please try again later.');
        reject();
      },
      () => {
        this.loadingSwitch = false;
      }
    );
  }
  startValue: Date | null = null;
  endValue: Date | null = null;
  @ViewChild('endDatePicker') endDatePicker!: NzDatePickerComponent;

  disabledStartDate = (startValue: Date): boolean => {
    if (!startValue || !this.endValue) {
      return false;
    }
    const endDate = new Date(this.endValue);
    if (isNaN(endDate.getTime())) {
      return false;
    }
    return startValue.getTime() > endDate.getTime();
  };
  
  // disabledStartDate = (startValue: Date): boolean => {
  //   console.log(startValue);
  //   console.log(this.endValue);
    
    
  //   if (!startValue || !this.endValue) {
  //     return false;
  //   }
  //   return startValue.getTime() > this.endValue.getTime();
  // };

  disabledEndDate = (endValue: Date): boolean => {
    if (!endValue || !this.startValue) {
      return false;
    }
    return endValue.getTime() <= this.startValue.getTime();
  };
  handleStartOpenChange(open: boolean): void {
    if (!open) {
      this.endDatePicker.open();
    }
    console.log('handleStartOpenChange', open);
  }

  handleEndOpenChange(open: boolean): void {
    console.log('handleEndOpenChange', open);
  }

  getEmailNamesWithCount(emailNames: string): string {
    const namesArray = emailNames.split(',');
    if (namesArray.length > 2) {
      return `${namesArray.slice(0, 2).join(', ')} ,+${namesArray.length - 2}more`;
    } else {
      return emailNames;
    }
  }
  



  
}
